module.exports = __webpack_public_path__ + "img/rotweinpur.f6a40717.jpg";